import ColumnMatcher from './ColumnMatcher';

export default ColumnMatcher;
